import { Card } from "@/atoms"
import { ModelLLM } from "@/icons"
import { IconResource } from "@/molecules/Resources"
import { ItemCardTemplate } from "../ItemCardTemplate"

import type { AgentAiApi, ModelAiApi } from "@/api/useInventory.types"

// The models an agent or a workflow runs on
export const ModelsCard = (props: {
  loading: boolean
  className: string
  models?: ModelAiApi[]
}) => {
  const { loading, className, models } = props

  return (
    <Card loading={loading} title="Models" className={className}>
      {models?.map(({ id, name, hosting, platform, vendor }) => (
        <ItemCardTemplate
          key={id}
          title={hosting === "remote" ? `${vendor} / ${name}` : name}
          description={hosting === "remote" ? `Remote (${platform})` : "Local"}
          icon={<ModelLLM />}
        />
      ))}
    </Card>
  )
}

// The resources of the project an agent or a workflow is in
export const RelatedResourcesCard = (props: {
  loading: boolean
  className: string
  resources?: NonNullable<AgentAiApi["project"]>["resources"]
}) => {
  const { loading, className, resources } = props

  return (
    <Card loading={loading} title="Related Resources" className={className}>
      {resources?.map(({ id, name, ...rest }) => (
        <ItemCardTemplate
          key={id}
          title={name}
          icon={<IconResource {...rest} imageSource="kodem" />}
        />
      ))}
    </Card>
  )
}
